/**
 * WhatsApp API Client
 * Phase 2: Wholesale Partnership Module
 */

import apiClient from '../client';

const BASE_URL = '/wholesale/whatsapp';

// ===== INBOX & MESSAGES =====

/**
 * Get WhatsApp inbox messages
 */
export const getInboxMessages = async (params = {}) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/inbox`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching WhatsApp inbox:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch WhatsApp inbox',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Send template message
 */
export const sendTemplateMessage = async (recipientPhone, templateId, variables = {}) => {
  try {
    const response = await apiClient.post(`${BASE_URL}/send-template`, {
      recipient_phone: recipientPhone,
      template_id: templateId,
      variables
    });
    return response.data;
  } catch (error) {
    console.error('Error sending template message:', error);
    throw {
      message: error.response?.data?.error || 'Failed to send template message',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Process outgoing message queue
 */
export const processMessageQueue = async () => {
  try {
    const response = await apiClient.post(`${BASE_URL}/process-queue`);
    return response.data;
  } catch (error) {
    console.error('Error processing message queue:', error);
    throw {
      message: error.response?.data?.error || 'Failed to process message queue',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

export default {
  getInboxMessages,
  sendTemplateMessage,
  processMessageQueue
};
